import { Button } from "@material-ui/core";
/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
/* eslint-enable no-restricted-imports */
import React, { useState, useEffect } from "react";

/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import "firebase/compat/firestore";
import "firebase/compat/auth";
/* eslint-enable no-restricted-imports */
import { EditForm, MyPageEditProfile, ContentsLayout } from "../../styles";

type Props = Record<string, never>;

const Container = MyPageEditProfile;

const DebugLogin: React.FC<Props> = (_props) => {
  const [token, setToken] = useState<string>("");

  const didMount = () => {};
  useEffect(didMount, []);

  const tokenLogin = async () => {
    console.log(token);
    try {
      const ret = await firebase.auth().signInWithCustomToken(token);
      console.log("Singed-in", ret);
    } catch (e) {
      console.error(e);
    }
  };

  // @ts-expect-error TS7006
  const updateToken = (event) => {
    const { value } = event.currentTarget;
    setToken(value);
  };

  return (
    <Container id="contents">
      <ContentsLayout>
        <div className="prifle_edit_info">
          <EditForm style={{ marginTop: "10px" }}>
            <input type="text" name="token" onChange={updateToken} />
            <Button onClick={tokenLogin}>Button</Button>
          </EditForm>
        </div>
      </ContentsLayout>
    </Container>
  );
};

export default DebugLogin;
